<div class="app-content filter">
    <div class="filter-header">
        <h2>Filter</h2>
        <span (click)="close()">
            <app-custom-icon
                [iconPath]="'assets/icons/general-icons.svg'"
                [imageName]="'icon-close'">
            </app-custom-icon>
        </span>
    </div>
    <mat-accordion>
        @if (filterForm | formControl:'status'; as control) {
            <app-sidebar-filter-panel
                [title]="'Status'"
                [controls]="[control]"
                [isEmpty]="!control.value.length">
                <div class="checkbox-list">
                    @for (status of statusList | keyvalue; track status.key) {
                        <app-checkbox
                            [view]="'button'"
                            [label]="status.value"
                            [checked]="control.value | formControlContainsOption:status.key"
                            (checkedChanged)="setCheckboxValue(control, $event, status.key)"></app-checkbox>
                    }
                </div>
                @if (
                    filterForm | formControl:'showArchived';
                    as showArchivedControl
                ) {
                    <div class="scoring-type">
                        <app-checkbox
                            [view]="'button'"
                            [label]="'Show Archived'"
                            [checked]="showArchivedControl.value"
                            (checkedChanged)="showArchivedControl.setValue($event)"></app-checkbox>
                    </div>
                }
            </app-sidebar-filter-panel>
        }

        @if (filterForm | formControl:'responsiblePilot'; as control) {
            <app-sidebar-filter-panel
                [title]="'Individual'"
                [controls]="[control]"
                [isEmpty]="!control.value">
                <app-select
                    [control]="control"
                    [optionList]="userList"
                    [placeholder]="'Select Pilot'"></app-select>
            </app-sidebar-filter-panel>
        }

        <app-group-filter-panels
            [filterForm]="filterForm"
            [options]="groupFilterOptions"></app-group-filter-panels>

        @if (filterForm | formControl:'timeFrame'; as control) {
            <app-sidebar-filter-panel
                [title]="'Time Frame (UTC)'"
                [controls]="[control, filterForm | formControl:'flightDate']"
                [isEmpty]="!control.value">
                <app-radio-list
                    [options]="timeFrameList"
                    [view]="'button-view'"
                    [direction]="'list-column'"
                    [currentSelection]="control.value"
                    (onChange)="setDateRangeValue(control, $event)"></app-radio-list>
            </app-sidebar-filter-panel>
        }

        @if (filterForm | formControl:'aircraft'; as control) {
            <app-sidebar-filter-panel
                [title]="'Aircraft'"
                [controls]="[control]"
                [isEmpty]="!control.value">
                <app-select
                    [control]="control"
                    [optionList]="aircraftList"
                    [placeholder]="'Select Aircraft'"></app-select>
            </app-sidebar-filter-panel>
        }

        @if (filterForm | formControl:'airport'; as control) {
            <app-sidebar-filter-panel
                [title]="'Airport'"
                [controls]="[control]"
                [isEmpty]="!control.value?.icao_code">
                <airport-picker
                    [control]="control"
                    [height]="40"></airport-picker>
            </app-sidebar-filter-panel>
        }

        <!-- <app-sidebar-filter-panel
            *ngIf="filterForm | formControl:'assessment' as control"
            [title]="'Form'"
            [controls]="[control]"
            [isEmpty]="!control.value">
            <app-radio-list
                [options]="formList"
                [view]="'button-view'"
                [direction]="'list-column'"
                [currentSelection]="control.value"
                (onChange)="control.setValue($event)"></app-radio-list>
        </app-sidebar-filter-panel> -->

        @if (filterForm | formControl:'formType'; as control) {
            <app-sidebar-filter-panel
                [title]="'Form Type'"
                [controls]="[control]"
                [isEmpty]="!control.value">
                <app-radio-list
                    [options]="formType"
                    [view]="'button-view'"
                    [direction]="'list-column'"
                    [currentSelection]="control.value"
                    (onChange)="control.setValue($event)"></app-radio-list>
            </app-sidebar-filter-panel>
        }
    </mat-accordion>

    <app-date-range-filter-modal
        [(visible)]="showDateRangeFilterModal"
        [control]="dateRangeFilterControl"
        (visibleChange)="onDateRangeFilterModalVisibleChange($event)" />
</div>
